(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dope-custom-studio"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = async (root) => {
      if (!root || root.dataset.initialized === "true") return;
      const [controller, ballTools, paddleTools, renderContract, draftTools] = await Promise.all([
        Promise.resolve(window.DopeCustomStudioControllerReady),
        Promise.resolve(window.DopeBallMaterialReady),
        Promise.resolve(window.DopePaddleMaterialReady),
        Promise.resolve(window.DopeStudioRenderContractReady),
        Promise.resolve(window.DopeStudioDraftReady)
      ]);
      if (!controller || typeof controller.initStudio !== "function") {
        root.dataset.initialized = "error";
        root.dataset.renderMode = "spec-only";
        root.querySelectorAll("[data-dp-download], [data-dp-purchase]").forEach((button) => {
          button.disabled = true;
          button.setAttribute("aria-disabled", "true");
        });
        const status = root.querySelector("[data-dp-status]");
        if (status) status.textContent = root.dataset.textRenderContractUnavailable || "Studio controls are unavailable. Use the contact link to submit a specification.";
        return;
      }
      root.__dopeStudioInstance = controller.initStudio(root, { ballTools, paddleTools, renderContract, draftTools });
      root.dispatchEvent(new CustomEvent('dope:studio-ready', { bubbles: true }));
    };

    const initializeAll = (scope) => {
      scope.querySelectorAll("[data-dp-custom-studio]").forEach((root) => {
        initialize(root);
      });
    };

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => initializeAll(document), { once: true });
    } else {
      initializeAll(document);
    }

    document.addEventListener("shopify:section:load", (event) => initializeAll(event.target));
    document.addEventListener("shopify:section:unload", (event) => {
      event.target.querySelectorAll("[data-dp-custom-studio]").forEach((root) => {
        if (typeof root.__dopeStudioDestroy === "function") root.__dopeStudioDestroy();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
